import { createSelector } from 'reselect'

import { CONNECTED_SERVICES } from '@lyrahealth-inc/shared-app-logic/src/features/connectedService/constants'

const getConnectedServiceState = ($$state: Map<string, any>) => $$state.get('connectedService')

export const getConnectedServices = createSelector(getConnectedServiceState, (connectedServiceState) =>
  connectedServiceState?.get('connectedServices'),
)

export const getConnectedServiceLoadingStatus = createSelector(getConnectedServiceState, (connectedServiceState) =>
  connectedServiceState?.get('connectedServiceLoadingStatus'),
)

export const getIsPersonifyActivated = createSelector(
  getConnectedServices,
  (connectedServices) =>
    connectedServices?.some((cs: Map<string, any>) => cs.get('service') === CONNECTED_SERVICES.PERSONIFY) ?? false,
)
